import { createWebHistory, createRouter } from "vue-router";
import Home from "@/components/Home"
import ContactUs from "@/components/ContactUs"
import Notice from "@/components/Notice"
import Portpolio from "@/components/Portpolio"
import Map from "@/components/Map"
import Intro from "@/components/Intro"
import History from "@/components/History"
import Hometown from "@/components/Hometown"
import Skylife from "@/components/Skylife"
import Reporter from "@/components/Reporter"
import Experience from "@/components/Experience"
import Insta from "@/components/Insta"
import Viral from "@/components/Viral"

const router = createRouter({
    history : createWebHistory(),
    routes : [
        { path : "/", name : "home", component : Home },
        { path : "/contact-us", name : "contact-us", component : ContactUs },
        { path : "/notice", name : "notice", component : Notice },
        { path : "/portpolio", name : "portpolio", component : Portpolio },
        { path : "/map", name : "map", component : Map },
        { path : "/intro", name : "intro", component : Intro },
        { path : "/history", name : "history", component : History },
        { path : "/service/hometown", name : "hometown", component : Hometown },
        { path : "/service/skylife", name : "skylife", component : Skylife },
        { path : "/service/reporter", name : "reporter", component : Reporter },
        { path : "/service/experience", name : "experience", component : Experience },
        { path : "/service/insta", name : "insta", component : Insta },
        { path : "/service/viral", name : "viral", component : Viral }

    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

export default router;
